import { render, staticRenderFns } from "./create-constitute.vue?vue&type=template&id=48d9f3a0&scoped=true&"
import script from "./create-constitute.vue?vue&type=script&lang=ts&"
export * from "./create-constitute.vue?vue&type=script&lang=ts&"
import style0 from "./create-constitute.vue?vue&type=style&index=0&id=48d9f3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9f3a0",
  null
  
)

component.options.__file = "create-constitute.vue"
export default component.exports